(function () {
  document.querySelectorAll('.lp-doctor-quotes__layout').forEach(function (section) {
    var track = section.querySelector('.lp-doctor-quotes__cards');
    var prevBtn = section.querySelector('.lp-doctor-quotes__nav-prev');
    var nextBtn = section.querySelector('.lp-doctor-quotes__nav-next');
    var fill = section.querySelector('.lp-doctor-quotes__progress-fill');

    if (!track || !prevBtn || !nextBtn) return;

    var cards = track.querySelectorAll('.lp-doctor-quotes__card');
    var total = cards.length;
    var currentIndex = 0;

    function getCardWidth() {
      var card = cards[0];
      return card ? card.offsetWidth + 12 : 0; // 12px = mobile gap
    }

    function updateProgress(index) {
      if (!fill) return;
      fill.style.width = ((index + 1) / total * 100) + '%';
    }

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, total - 1));
      track.scrollTo({ left: currentIndex * getCardWidth(), behavior: 'smooth' });
      updateProgress(currentIndex);
    }

    prevBtn.addEventListener('click', function () {
      goTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function () {
      goTo(currentIndex + 1);
    });

    // Sync index and progress on manual swipe
    track.addEventListener('scroll', function () {
      var cardWidth = getCardWidth();
      if (!cardWidth) return;
      var index = Math.round(track.scrollLeft / cardWidth);
      if (index !== currentIndex) {
        currentIndex = index;
        updateProgress(currentIndex);
      }
    }, { passive: true });

    // Set initial progress
    updateProgress(0);
  });
})();
